module.exports = __webpack_public_path__ + "static/media/Logo_Octiva_WHITE_RGB_no_text.73ebc7e6.png";